module.exports = __webpack_public_path__ + "media/images/espace de coworking-849587314604e6fd6656f37d4519d06d.svg";